import Footer from "../../Footer/Footer";
import Header from "../../Header/Header";

import BlockContent from "../../Block/BlockContent";
import BlockTitle from "../../Block/BlockTitle";
import BlockSubtitle from "../../Block/BlockSubtitle";
import BlockText from "../../Block/BlockText";
import BlockButton from "../../Block/BlockButton";
import Block from "../../Block/Block";
import BlockImage from "../../Block/BlockImage";

function FlyCamXR() {
  return (
    <div>
      <Header/>        

      <div style={{backgroundImage:'url("/Home/pointwave.webp")', 
                  height:"200px",
                  width: "100%",
                  backgroundSize: "100% 100%",
                  backgroundPosition: "bottom"}}>
      </div>

      <Block colorTheme="light" gridTemplateColumns="600px 600px">
        <BlockContent>
          <BlockTitle>FlyCamXR</BlockTitle>
          {/* <BlockSubtitle>Autonomous Camera Drones for Interactive Experiences in Extended Reality Telepresence Applications with enhanced Naturalness</BlockSubtitle> */}
        </BlockContent>
        <BlockContent>
          <BlockText>This DAAD-sponsored project brings together the University of Applied Sciences Jena and the Anna University to strengthen collaboration between both institutions through joint research activities.</BlockText>
        </BlockContent>
      </Block>


      <Block gridTemplateColumns="600px 600px">
        <BlockContent>
          <BlockSubtitle>Details</BlockSubtitle>
        </BlockContent>
        <BlockContent>
          <BlockText><b>Project Start:</b> 01.01.2023</BlockText>
          <BlockText><b>Project End:</b> 01.01.2025</BlockText>
          <BlockText><b>Budget:</b> € 12.200</BlockText>
          <BlockText><b>Partners:</b> Anna University</BlockText>
        </BlockContent>
      </Block>

      <Block colorTheme="light" gridTemplateColumns="600px 600px">
        <BlockContent width="100%">
          <BlockText>This project established an academic research exchange between Ernst-Abbe-Hochschule Jena and Anna University, fostering collaboration in computer vision, 3D reconstruction, and photogrammetric scene processing.
          <br/><br/>
          Rather than focusing on a single technical system, the initiative emphasized knowledge transfer, joint experimentation, and cultural exchange through reciprocal research visits. Researchers from both institutions worked closely together on shared problems, gaining insights into complementary methodologies and workflows.
          <br/><br/>
          The joint research focused on drone-based (UAV) image acquisition and photogrammetric 3D reconstruction of real-world environments. A particular emphasis was placed on post-processing techniques to improve reconstruction quality, including shadow removal and illumination normalization to enhance geometric and visual consistency.
          <br/><br/>
          The collaboration resulted in a co-authored scientific publication and laid the foundation for future work in robust outdoor reconstruction and scene enhancement for visualization and analysis tasks.
          <br/><br/>
          Beyond technical outcomes, the project strengthened long-term academic partnerships and enabled interdisciplinary exchange between students and researchers from both countries.</BlockText>
        </BlockContent>
        <BlockContent>
              <BlockImage src={process.env.PUBLIC_URL + '/images/projects/chennaiStud.webp'} title="Figure 1: Visit to Anna University, discussing the collaborative research project with students."/>
        </BlockContent>
      </Block>

 
      <Footer/>
    </div>
  );
}

export default FlyCamXR;